import { Home, Building, Book, Sms, Setting2, WalletMoney, MoneyTime, Teacher, Health, DollarSquare, Information, Calendar, VideoPlay, Link21, HeartTick } from 'iconsax-react';
import { tipologiaStruttura } from '../../components/Util/enum';
import { BadgeCount } from './BadgeCount';

export const MenuStrutturaList = ({ badgeCount, unpaidCount, rejectedCount, profile, linkAcquisto = false }) => {

    let clubNature = profile?.club?.clubNature ?? null;
    if (!clubNature) {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            clubNature = tokenDetails.clubNature;
        }
    }

    const isASD = clubNature === tipologiaStruttura.ASD.value;
    const isSSD = clubNature === tipologiaStruttura.SSD.value;
    const isCapitalCompany = clubNature === tipologiaStruttura.CAPITAL_COMPANY.value;
    // Organismo sociale visibile per ASD, SSD e società di capitali (srl/spa); nascosto per ditta individuale.
    const showMiaAssociazione = isASD || isSSD || isCapitalCompany;

    const idsIncomplete = profile && profile.club && (
        !profile.club.name ||
        !profile.club.phoneNumber ||
        !profile.club.spokenLocales || profile.club.spokenLocales.length === 0 ||
        !profile.club.incorporationYear ||
        !profile.club.clubNature ||
        !profile.club.clubSubNature ||
        !profile.club.legalRepresentativeFirstName ||
        !profile.club.legalRepresentativeLastName ||
        !profile.club.legalRepresentativeBirthPlace ||
        !profile.club.legalRepresentativeCity ||
        !profile.club.legalRepresentativeAddress ||
        !profile.club.legalRepresentativeTaxCode ||
        !profile.club.address?.streetAddress ||
        !profile.club.address?.locality ||
        !profile.club.address?.province ||
        !profile.club.address?.postalCode ||
        !profile.club.address?.country ||
        !profile.club.legalAddress?.streetAddress ||
        !profile.club.legalAddress?.locality ||
        !profile.club.legalAddress?.province ||
        !profile.club.legalAddress?.postalCode ||
        !profile.club.legalAddress?.country
    );
    const sportIncomplete = profile && profile.club && (!profile.club.sports || profile.club.sports.length === 0);
    const copertinaIncomplete = profile && profile.club && ((!profile.club.pictures || profile.club.pictures.length === 0) || !profile.club.logo);
    const fatturazioneRejected = profile?.club?.invoiceDataSender?.status === 'REJECTED';
    const fatturazioneWaiting = profile?.club?.invoiceDataSender?.status === 'WAIT_RESPONSE';
    const hasProfileIncomplete = idsIncomplete || sportIncomplete || copertinaIncomplete;
    const showMiaStrutturaAlert = hasProfileIncomplete || fatturazioneRejected || fatturazioneWaiting;
    const miaStrutturaAlertColor = (fatturazioneRejected || hasProfileIncomplete) ? '#ff6b6b' : '#ffc107';
    const menuItems = [
        {
            title: 'Dashboard',
            iconStyle: <span><Home size={16} color="currentColor" /></span>,
            to: '/struttura/dashboard',
        },
        {
            title: 'Calendario',
            iconStyle: <span><Calendar size={16} color="currentColor" /></span>,
            to: '/struttura/calendario/eventi',
        },
        { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
        {
            title: (
                <span>
                    La mia struttura
                    {showMiaStrutturaAlert && (
                        <span style={{ marginLeft: '4px' }}>
                            <Information variant="Bulk" size={14} color={miaStrutturaAlertColor} />
                        </span>
                    )}
                </span>
            ),
            iconStyle: <span><Building size={16} color="currentColor" /></span>,
            to: '/struttura/lamiastruttura',
        },
        ...(showMiaAssociazione ? [{
            title: 'Organismo sociale',
            classsChange: 'mm-collapse',
            iconStyle: <span><Building size={16} color="currentColor" /></span>,
            content: [
                // Libro Soci: ASD, SSD e società di capitali (srl/spa)
                { title: 'Libro Soci', to: 'struttura/soci/list' },
                // Registro Tesserati: solo ASD e SSD (le società di capitali non hanno tesserati)
                ...((isASD || isSSD) ? [
                    { title: 'Elenco Tesserati', to: 'struttura/tesserati/list' },
                ] : []),
                {
                    title: 'Consiglio direttivo',
                    to: 'struttura/cda/list',
                },
                {
                    title: 'Assemblee',
                    to: 'struttura/assemblee',
                },
            ]
        }] : []),
        {
            title: 'Anagrafiche',
            classsChange: 'mm-collapse',
            iconStyle: <span><Book size={16} color="currentColor" /></span>,
            content: [
                { title: 'Player', to: 'struttura/clienti/list' },
                { title: 'Junior', to: 'struttura/junior/list' },
            ],
        },
        {
            title: 'Certificati medici',
            iconStyle: <span><HeartTick size={16} color="currentColor" /></span>,
            to: '/struttura/certificati',
        },
        {
            title: 'Richieste',
            iconStyle: <span><Sms size={16} color="currentColor" /></span>,
            to: '/struttura/richieste',
            badge: badgeCount,
        },
        { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
        {
            title: 'Abbonamenti',
            classsChange: 'mm-collapse',
            iconStyle: <span><MoneyTime size={16} color="currentColor" /></span>,
            content: [
                { title: 'Elenco Abbonamenti', to: 'struttura/booking/subscriptions' },
                { title: 'Nuova vendita', to: 'struttura/booking/userSubscriptions/new' },
            ],
        },
        {
            // Corsi e squadre: il menu porta alla gestione nuova (pages/struttura/corsi).
            // Le pagine vecchie restano nel codice, raggiungibili solo per indirizzo:
            // sono marcate in testa con «VECCHI FILE GESTIONE CORSI».
            title: 'Corsi e squadre',
            classsChange: 'mm-collapse',
            iconStyle: <span><Health size={16} color="currentColor" /></span>,
            content: [
                { title: 'Elenco corsi', to: 'struttura/corsi' },
                { title: 'Elenco squadre', to: 'struttura/corsi/squadre' },
                { title: 'Nuovo partecipante', to: 'struttura/corsi/partecipanti/nuovo' },
            ],
        },
        {
            title: 'Impianti',
            classsChange: 'mm-collapse',
            iconStyle: <span><Building size={16} color="currentColor" /></span>,
            content: [
                { title: 'Anagrafica Impianti', to: 'struttura/booking/facilities' },
                { title: 'Prenotazioni', to: 'struttura/booking/facilities/calendar' },
                { title: 'Nuova prenotazione', to: 'struttura/booking/userFacilities' },
            ],
        },
        {
            title: 'Maestri',
            classsChange: 'mm-collapse',
            iconStyle: <span><Teacher size={16} color="currentColor" /></span>,
            content: [
                { title: 'Anagrafica maestri', to: 'struttura/maestri/list' },
                { title: 'Elenco Lezioni', to: 'struttura/booking/lessons' },
                { title: 'Prenotazioni', to: 'struttura/booking/lessons/calendar' },
                { title: 'Nuova prenotazione', to: 'struttura/booking/userLessons' },
            ],
        },
        // I link d'acquisto di tutti i prodotti vendibili online (solo dove i link sono accesi).
        ...(linkAcquisto ? [{
            title: 'Link prodotti',
            iconStyle: <span><Link21 size={16} color="currentColor" /></span>,
            to: '/struttura/link',
        }] : []),
        { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
        {
            title: 'Amministrazione',
            badge: (unpaidCount || 0) + (rejectedCount || 0),
            classsChange: 'mm-collapse',
            iconStyle: <span><DollarSquare size={16} color="currentColor" /></span>,
            content: [
                { title: <span>Ordini <BadgeCount count={unpaidCount} /></span>, to: 'struttura/booking/sales' },
                { title: <span>Fatture e ricevute <BadgeCount count={rejectedCount} /></span>, to: 'struttura/booking/userTransactions' },
                ...(isASD ? [{ title: 'Consulenza', to: 'struttura/consulenza' }] : []),
            ],
        },
        {
            title: 'Bilancio',
            iconStyle: <span><MoneyTime size={16} color="currentColor" /></span>,
            to: '/struttura/bilancio',
        },
        {
            title: 'FitCoin',
            classsChange: 'mm-collapse',
            iconStyle: <span><WalletMoney size={16} color="currentColor" /></span>,
            content: [
                { title: 'Wallet', to: 'struttura/fitcoin/wallet' },
                { title: 'Promozioni', to: 'struttura/fitcoin/promozioni' },
            ],
        },
        { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
        {
            title: 'Kit Comunicazione',
            iconStyle: <span><Sms size={16} color="currentColor" /></span>,
            to: '/struttura/kitcomunicazione',
        },
        {
            title: 'DonAction',
            iconStyle: <span><WalletMoney size={16} color="currentColor" /></span>,
            to: '/struttura/referral',
        },
        { title: <hr style={{ margin: '8px 16px', borderTop: '1px solid #e5e7eb', opacity: 0.6 }} />, classsChange: 'menu-title' },
        {
            title: 'Wiki',
            iconStyle: <span><VideoPlay size={16} color="currentColor" /></span>,
            to: '/struttura/wiki',
        },
        {
            // Una voce sola: le pagine di impostazione hanno il loro menu intermedio (layouts/MenuImpostazioni.js)
            title: 'Impostazioni',
            iconStyle: <span><Setting2 size={16} color="currentColor" /></span>,
            to: '/struttura/strumenti/abbonamento-info',
            attivoSu: ['/struttura/strumenti/abbonamento-info'],
        },
    ];

    return { menuItems };
}
